import { SaveReportFile } from "projects/sepidz-web-framework/src/lib/models";

export class ImportAndExportModel {
  IsUpload: boolean;
  PathUpload: string;
  FilePath: string;
  ImportOrExportId : number;
  SaveReportFile : SaveReportFile[];
  constructor(){
    this.IsUpload = false;
    this.PathUpload = "";
    this.FilePath = "";
    this.ImportOrExportId = 1;
    this.SaveReportFile = [];
  }
}
